module.exports = __webpack_public_path__ + "static/media/speakers5.b2a63333.jpg";